import { AddressKind } from '@/common/enums/AddressKind';
import type {
	GusAddress,
	OrganizationAddressDraft,
	OrganizationLocation,
} from '@/organization/organization/organization.model';

export const toGusHeadquartersAddress = (
	address: GusAddress,
	locations: OrganizationLocation[],
): OrganizationAddressDraft => {
	const matched = address.location;

	return {
		address: address.address,
		zipCode: address.zipCode,
		location: matched ? (locations.find((location) => location.id === matched.id) ?? matched) : null,
		kind: AddressKind.HEADQUATERS,
	};
};
